interface ResettableStore {
  $reset: () => void
}

// Stores whose data is scoped to the currently selected profile (B2B/B2C). On a profile
// switch they are reset to their initial state so no page can read data belonging to the
// previous profile. `me` and `auth` carry the user identity/session and are preserved.
// Callers pass in the store factories to reset, so this module has no @/stores/* imports
// of its own and cannot form an import cycle with any store.
export const resetProfileScopedStores = (storeFactories: Array<() => ResettableStore>) => {
  storeFactories.forEach((useStore) => useStore().$reset())
}
